module.exports = __webpack_public_path__ + "img/fedex-c.1a1f8340.png";